// FUNCTIONS
async function ajaxRenderPositions(filter, page, pagination) {
	try {
		const formData = new FormData();

		formData.append('action', 'ajaxRenderPositions');
		formData.append('filter', filter);
		formData.append('page', page);
		formData.append('pagination', pagination);

		const response = await fetch(adminAjax, {
			body: formData,
			method: 'POST'
		});

		if (!response.ok) {
			throw new Error('Failed to fetch positions.');
		} else {
			const message = await response.json();

			document.querySelector('.results').replaceChildren();
			document.getElementById('position-pagination')?.remove();

			if (filter && paginationChangeInitialized) {
				paginationChangeInitialized = false;
			}

			if (document.getElementById('position-pagination')) {
				document.getElementById('position-pagination').insertAdjacentHTML('beforebegin', message.data);
			} else {
				document.querySelector('.results').insertAdjacentHTML('beforeend', message.data);
			}

			document.querySelectorAll('.position').forEach((element) => {
				fadeIn(element, 800);
			});

			if (!paginationChangeInitialized && document.getElementById('position-pagination') !== null) {
				paginationChangeInitialized = true;
			}
		}
	} catch (error) {
		console.error(error);
		alert('Cannot connect to the server. Please try again later.');
	}
}

const showPositionsInitial = () => {
	document.querySelectorAll('.callout input[class$="-image"]').forEach((element) => {
		const check = element.classList.contains('callout-1-image-desktop') || element.classList.contains('callout-1-image-mobile');

		if (!check) {
			imageArray.push(element.value);
		}
	});

	preloadImages(imageArray);

	if (window.location.hash) {
		document.querySelector('#positions-filter option[value="' + window.location.hash.substring(1) + '"]').selected = true;
		ajaxRenderPositions(window.location.hash.substring(1), 1, true);
	}
};

const updateCalloutBlockCopy = () => {
	const heading3 = document.querySelector('.callout-' + currentNumber + '-heading').value;
	const imageDesktop = document.querySelector('.callout-' + currentNumber + '-desktop-image').value;
	const imageMobile = document.querySelector('.callout-' + currentNumber + '-mobile-image').value;
	const paragraph = document.querySelector('.callout-' + currentNumber + '-copy').value;

	document.querySelector('.callout aside h3').textContent = heading3;
	document.querySelector('.callout aside p').textContent = paragraph;
	document.querySelector('.callout img.desktop').src = imageDesktop;
	document.querySelector('.callout img.mobile').src = imageMobile;

	currentNumberElement.textContent = leftPad(currentNumber, 2);
};

// VARIABLES
const currentNumberElement = document.querySelector('.current-number');
const maxNumber = parseInt(document.querySelector('.max-number').textContent);
const positions = document.querySelector('.positions');

let currentNumber = parseInt(currentNumberElement.innerText);
let imageArray = new Array;

// INITIALIZATION
showPositionsInitial();

// EVENT LISTENERS
document.getElementById('positions-filter').addEventListener('change', (event) => {
	const filter = event.currentTarget.value == 'all' ? false : event.currentTarget.value;
	const hash = event.currentTarget.value == 'all' ? window.location.pathname : '#' + filter;

	ajaxRenderPositions(filter, 1, true);
	history.replaceState(undefined, undefined, hash);
});

document.querySelector('.anchor').addEventListener('click', (event) => {
	event.preventDefault();
	animatedScroll(document.querySelector('a[name="' + event.currentTarget.href.replace('#', '') + '"]'));
});

document.querySelector('.controls .next').addEventListener('click', () => {
	if (currentNumber == maxNumber) {
		currentNumber = 1;
	} else {
		currentNumber++;
	}

	updateCalloutBlockCopy();
});

document.querySelector('.controls .prev').addEventListener('click', () => {
	if (currentNumber == 1) {
		currentNumber = maxNumber;
	} else {
		currentNumber--;
	}

	updateCalloutBlockCopy();
});

positions.addEventListener('change', (event) => {
	if (event.target.matches('#position-pagination')) {
		let filter;

		if (window.location.hash) {
			filter = window.location.hash.substring(1);
		} else {
			filter = false;
		}

		ajaxRenderPositions(filter, event.target.value, false);
	}
});

positions.addEventListener('click', (event) => {
	if (event.target.closest('.position h4')) {
		const arrow = event.target.querySelector('i');
		const longDescription = event.target.parentElement.querySelector('.long-description');

		if (arrow.classList.contains('icon-arrow-down')) {
			arrow.classList.replace('icon-arrow-down', 'icon-arrow-up');
			fadeIn(longDescription);
		} else {
			arrow.classList.replace('icon-arrow-up', 'icon-arrow-down');
			fadeOut(longDescription);
		}
	}
});